import {
    ArrayField, BooleanField, Datagrid,
    List, NumberField, Pagination, SelectInput, TextField,

} from "react-admin";

import { ImageFieldExt } from "@/src/components";
import { CountriesListField } from "./CountriesListField";
import { StoreRefsField } from "./StoreRefsField";


const ProductPagination = () => <Pagination rowsPerPageOptions={[10, 25, 50]} />;
const filter = [
    <SelectInput label="Active" source="active" alwaysOn choices={[
        { id: 'true', name: "Yes" },
        { id: 'false', name: "No" },
    ]} />,
    <SelectInput label="Store Product" source="storeProduct" alwaysOn choices={[
        { id: 'true', name: "Yes" },
        { id: 'false', name: "No" },
    ]} />
]
export const CreditProductList = () => {

    return (
        <List
            perPage={10}
            pagination={<ProductPagination />}
            filters={filter}
            sort={{ field: 'displayOrder', order: 'ASC' }}
            exporter={false}
        >
            <Datagrid rowClick="edit">

                <TextField source="title" />
                <ImageFieldExt source="imageUrl" label="Image" />
                <BooleanField source="active" />
                <BooleanField source="storeProduct" label="Store Product" />
                <BooleanField source="recommended" label="Recm." />

                <NumberField source="count" />

                <NumberField source="displayOrder" />

                <StoreRefsField source="storeRefs" label="Store / SKU" />
                <TextField source="target.role" />
                <TextField source="target.gender" />
                <NumberField source="target.age.min" />
                <NumberField source="target.age.max" />

                
                <ArrayField source="pricing">
                    <Datagrid bulkActionButtons={false} empty={"NA"}>
                        <TextField source="currency" />
                        <CountriesListField />

                        <NumberField source="price" />
                        <NumberField source="priceOld" />
                    </Datagrid>
                </ArrayField>



            </Datagrid>
        </List>
    );
}

